import { ConfigService } from "./app.config.service";

export function configInitializer(_configService: ConfigService) {
    return async () => {
        await _configService.getConfig();
    }
}